export default __webpack_public_path__ + "static/media/mayi.08471df0.png";